import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-145">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center px-4" data-id="element-146">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-147" />

          {/* Modal Content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="relative w-full max-w-2xl max-h-[80vh] bg-[#111827] border border-white/10 rounded-2xl shadow-2xl overflow-hidden" data-id="element-148">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-white/10" data-id="element-149">
              <h3 className="text-xl font-heading font-bold text-white" data-id="element-150">
                {title}
              </h3>
              <button onClick={onClose} className="p-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-white/10 transition-colors" data-id="element-151">
                <X className="w-5 h-5" data-id="element-152" />
              </button>
            </div>

            {/* Body */}
            <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-slate-300 text-sm leading-relaxed space-y-4" data-id="element-153">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}